import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/date.svg';
const DateIcon = (props: any): ReactElement => {
  return (
    <img
      alt="calendar-icon"
      src={icon}
      height={'15px'}
      width={'15px'}
      {...props}
    />
  );
};
export default DateIcon;
